import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { GoogleLogo, ShieldCheck } from '@phosphor-icons/react';

export default function Login() {
  const { user } = useAuth();

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (user) { window.location.href = '/dashboard'; return null; }

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[hsl(222,47%,11%)] text-slate-100">
      {/* Left visual */}
      <div className="relative hidden lg:block">
        <img src="https://images.unsplash.com/photo-1511454493857-0a29f2c023c7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
          alt="Site industriel" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-tr from-[hsl(222,47%,11%)] via-[hsl(222,47%,11%)]/70 to-transparent" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-sm border-2 border-sky-400 flex items-center justify-center font-black">MOC</div>
            <span className="font-display font-bold text-lg">Gestion du changement</span>
          </div>
          <div>
            <h1 className="font-display text-4xl xl:text-5xl font-black leading-none tracking-tight">Maîtriser<br />chaque<br />modification.</h1>
            <p className="mt-6 max-w-md text-slate-300 leading-relaxed">
              Workflow MOC de bout en bout — identification, analyse des risques, PSSR, implémentation et clôture. Sécurité et conformité, sans compromis.
            </p>
          </div>
          <div className="text-xs uppercase tracking-[0.2em] text-sky-300/70">Lafarge · Geocycle</div>
        </div>
      </div>

      {/* Right auth */}
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-3 mb-10">
            <div className="w-11 h-11 rounded-sm border-2 border-sky-400 flex items-center justify-center font-black">MOC</div>
            <span className="font-display font-bold text-lg">Gestion du changement</span>
          </div>
          <h2 className="font-display text-3xl font-bold tracking-tight">Connexion</h2>
          <p className="mt-3 text-slate-400 text-sm leading-relaxed">
            Accès réservé aux comptes autorisés. La vérification du domaine
            (<span className="text-sky-300">@lafarge.com</span>, <span className="text-sky-300">@geocycle.com</span>)
            est effectuée côté serveur.
          </p>

          <Button data-testid="google-login-button" onClick={handleLogin}
            className="mt-8 w-full h-11 bg-white text-slate-900 hover:bg-slate-100">
            <GoogleLogo size={20} weight="bold" className="mr-2" /> Se connecter avec Google
          </Button>

          <div className="mt-8 flex items-start gap-3 text-xs text-slate-400 bg-white/5 border border-white/10 rounded-sm p-4">
            <ShieldCheck size={18} weight="bold" className="text-sky-400 shrink-0 mt-0.5" />
            <span>Aucune donnée métier n'est stockée sur cet appareil. Seuls les brouillons non soumis restent temporairement en local.</span>
          </div>
        </div>
      </div>
    </div>
  );
}
